var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _text, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _rect11, _rect12, _rect13, _text2, _rect14, _circle2, _rect15, _rect16, _rect17, _text3, _rect18, _circle3, _rect19, _rect20, _rect21, _text4, _rect22, _text5, _g, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _text6, _text7, _text8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartScheduling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 540",
    fill: "none",
    role: "img",
    "aria-label": "Smart scheduling dashboard with queues and posting times",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smaSchBg",
    x1: 0,
    y1: 0,
    x2: 880,
    y2: 540,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0a1628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smaSchAccent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a00a8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 540,
    rx: 16,
    fill: "url(#smaSchBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 832,
    height: 56,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 180,
    height: 14,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 64,
    width: 120,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 40,
    width: 132,
    height: 32,
    rx: 10,
    fill: "url(#smaSchAccent)",
    fillOpacity: 0.65
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 722,
    y: 61,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff"
  }, "Auto-optimize")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 100,
    width: 520,
    height: 416,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.04
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 120,
    width: 160,
    height: 10,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 140,
    width: 100,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.28
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 168,
    width: 480,
    height: 8,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.08
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 188,
    width: 480,
    height: 56,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05,
    stroke: "#9e00ff",
    strokeOpacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 216,
    r: 10,
    fill: "#E1306C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 206,
    width: 120,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 220,
    width: 180,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.35
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 206,
    width: 72,
    height: 22,
    rx: 8,
    fill: "url(#smaSchAccent)",
    fillOpacity: 0.45
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 221,
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#f5d4ff"
  }, "6:30 PM best")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 256,
    width: 480,
    height: 56,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 284,
    r: 10,
    fill: "#1877F2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 274,
    width: 140,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 288,
    width: 160,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.35
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 274,
    width: 72,
    height: 22,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.12
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 396,
    y: 289,
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#fff",
    fillOpacity: 0.6
  }, "9:00 AM")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 324,
    width: 480,
    height: 56,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 352,
    r: 10,
    fill: "#0A66C2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 342,
    width: 150,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 356,
    width: 170,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.35
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 342,
    width: 72,
    height: 22,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.12
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 357,
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#fff",
    fillOpacity: 0.6
  }, "11:15 AM")), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 396,
    width: 480,
    height: 100,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.04
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 418,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff",
    fillOpacity: 0.55
  }, "Audience activity heatmap")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 432,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#9e00ff",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 458,
    width: 28,
    height: 20,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.06
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 100,
    width: 296,
    height: 416,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.04
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 120,
    width: 140,
    height: 10,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.7
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 140,
    width: 100,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.28
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 168,
    width: 256,
    height: 64,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 184,
    width: 100,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.75
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 200,
    width: 160,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.3
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 214,
    width: 56,
    height: 10,
    rx: 4,
    fill: "#25D366",
    fillOpacity: 0.4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 244,
    width: 256,
    height: 64,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 260,
    width: 120,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.75
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 276,
    width: 180,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.3
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 290,
    width: 64,
    height: 10,
    rx: 4,
    fill: "url(#smaSchAccent)",
    fillOpacity: 0.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 320,
    width: 256,
    height: 64,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 336,
    width: 110,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.75
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 352,
    width: 150,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.3
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 366,
    width: 52,
    height: 10,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 400,
    width: 256,
    height: 96,
    rx: 10,
    fill: "url(#smaSchAccent)",
    fillOpacity: 0.12,
    stroke: "#9e00ff",
    strokeOpacity: 0.25
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 596,
    y: 426,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#f0c8ff"
  }, "AI suggestion")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 596,
    y: 448,
    fontFamily: "system-ui,sans-serif",
    fontSize: 13,
    fill: "#fff",
    fillOpacity: 0.85
  }, "Shift Instagram post to 6:30 PM")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 596,
    y: 468,
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#fff",
    fillOpacity: 0.5
  }, "+24% predicted engagement")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartScheduling);
export default __webpack_public_path__ + "static/media/smart-scheduling.20383d1e0f851d1953ceb9d49ca41647.svg";
export { ForwardRef as ReactComponent };